import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paymentMethodField", "cashButton", "cardButton", "paymentForm", "cashFeeText", "cardFeeText", "submitBtn", "payButtonText", "cashButtonText"]

  connect() {
    // set default payment method to card if it's not set
    if (!this.paymentMethodFieldTarget.value) {
      this.paymentMethodFieldTarget.value = "card"
    }

    // Initialize visibility based on current payment method
    this.updateVisibility()
  }

  selectCash(event) {
    event.preventDefault()
    this.paymentMethodFieldTarget.value = "cash"
    this.hidePaymentForm()
    this.updateActiveButton("cash")
    this.updateFeeText("cash")
    this.updateSubmitButtonText("cash")
  }

  selectCard(event) {
    event.preventDefault()
    this.paymentMethodFieldTarget.value = "card"
    this.showPaymentForm()
    this.updateActiveButton("card")
    this.updateFeeText("card")
    this.updateSubmitButtonText("card")
  }

  hidePaymentForm() {
    if (this.hasPaymentFormTarget) {
      this.paymentFormTarget.style.display = "none"
    }
  }

  showPaymentForm() {
    if (this.hasPaymentFormTarget) {
      this.paymentFormTarget.style.display = "block"
    }
  }

  updateActiveButton(selectedMethod) {
    // Remove active class from both buttons (if they exist)
    if (this.hasCashButtonTarget) {
      this.cashButtonTarget.classList.remove("product-thumb-active")
    }
    if (this.hasCardButtonTarget) {
      this.cardButtonTarget.classList.remove("product-thumb-active")
    }

    // Add active class to selected button (if it exists)
    if (selectedMethod === "cash" && this.hasCashButtonTarget) {
      this.cashButtonTarget.classList.add("product-thumb-active")
    } else if (selectedMethod === "card" && this.hasCardButtonTarget) {
      this.cardButtonTarget.classList.add("product-thumb-active")
    }
  }

  updateVisibility() {
    const currentMethod = this.paymentMethodFieldTarget.value
    if (currentMethod === "card") {
      this.showPaymentForm()
      this.updateActiveButton("card")
      this.updateFeeText("card")
      this.updateSubmitButtonText("card")
    } else {
      this.hidePaymentForm()
      this.updateActiveButton("cash")
      this.updateFeeText("cash")
      this.updateSubmitButtonText("cash")
    }
  }

  updateFeeText(selectedMethod) {
    // Show appropriate fee text based on payment method
    if (selectedMethod === "cash") {
      // Show cash fee text, hide card fee text
      if (this.hasCashFeeTextTarget) {
        this.cashFeeTextTarget.style.display = ""
      }
      if (this.hasCardFeeTextTarget) {
        this.cardFeeTextTarget.style.display = "none"
      }
    } else if (selectedMethod === "card") {
      // Show card fee text, hide cash fee text
      if (this.hasCashFeeTextTarget) {
        this.cashFeeTextTarget.style.display = "none"
      }
      if (this.hasCardFeeTextTarget) {
        this.cardFeeTextTarget.style.display = ""
      }
    }
  }

  updateSubmitButtonText(selectedMethod) {
    if (!this.hasSubmitBtnTarget) return

    if (selectedMethod === "card" && this.hasPayButtonTextTarget) {
      this.submitBtnTarget.value = this.payButtonTextTarget.value
    } else if (selectedMethod === "cash" && this.hasCashButtonTextTarget) {
      this.submitBtnTarget.value = this.cashButtonTextTarget.value
    }
  }
}
